<template>
  <v-card>
    <v-container class="pb-0">
      <v-card-title class="mb-3 text-button pt-0">{{ formTitle }}</v-card-title>
      <v-card-text class="px-0">
        <v-form v-model="isFormValid" ref="form" @submit.prevent="save()">
          <v-row :no-gutters="isMobile">
            <v-col :cols="isMobile ? 12 : 8" class="py-1">
              <v-text-field
                label="Nombre"
                variant="outlined"
                density="compact"
                v-model="financiador.name"
                :rules="
                  rules.required.concat([rules.maxLength(financiador.name, 50)])
                "
              ></v-text-field>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-1">
              <v-text-field
                label="Código"
                density="compact"
                variant="outlined"
                v-model="financiador.code"
                :rules="
                  rules.required.concat([rules.maxLength(financiador.code, 50)])
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                label="URL"
                variant="outlined"
                density="compact"
                v-model="financiador.url"
                :rules="
                  financiador.usaGecros 
                    ? rules.required.concat(
                        [rules.maxLength(financiador.url, 150)],
                        rules.validUrl
                      )
                    : financiador.url.length > 0 ? [rules.maxLength(financiador.url, 150)].concat(rules.validUrl) : []
                "
              ></v-text-field>
            </v-col>

            <v-col :cols="isMobile ? 12 : 4" class="pb-0">
              <v-select
                v-model="financiador.valUniFechaVenc"
                label="Unidad validación fecha vencimiento"
                :items="unidadFechaVencList"
                variant="outlined"
                clearable
                density="compact"
                @update:model-value="financiador.valCantFechaVenc = null"
                item-title="desc"
                item-value="value"
                id="v-select-unidad"
              ></v-select>
            </v-col>

            <v-col :cols="isMobile ? 12 : 4" class="pb-0">
              <v-text-field
                v-if="financiador.valUniFechaVenc"
                v-model="financiador.valCantFechaVenc"
                label="Cantidad validación fecha vencimiento"
                type="number"
                variant="outlined"
                :disabled="!financiador.valUniFechaVenc"
                density="compact"
                min="1"
                :rules="
                  financiador.valUniFechaVenc
                    ? rules.required.concat(rules.validNumberRule)
                    : []
                "
              >
              </v-text-field>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="pb-0">
              <v-text-field
                v-model="financiador.valDiasEmisionFutura"
                label="Días de emisión a futuro"
                type="number"
                variant="outlined"
                density="compact"
                min="0"
                :rules="rules.validNumberRule"
              >
              </v-text-field>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-0">
              <v-switch
                v-model="financiador.perReverDispensa"
                color="primary"
                label="Permite revertir dispensa"
              >
              </v-switch>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-0">
              <v-text-field
                v-model="financiador.hsRevertirDispensa"
                label="Cantidad horas tolerancia"
                hint="Cantidad horas tolerancia revertir dispensa"
                persistent-hint
                type="number"
                variant="outlined"
                :disabled="!financiador.perReverDispensa"
                density="compact"
                min="1"
                :rules="
                  financiador.perReverDispensa
                    ? rules.required.concat(rules.validNumberRule)
                    : []
                "
              ></v-text-field>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-0" v-if="financiador.usaGecros">
              <v-switch
                v-model="financiador.usaAlfaBetaPropio"
                color="primary"
                label="Usar Alfa Beta propio"
              >
              </v-switch>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-n4" v-if="financiador.usaGecros">
              <v-switch
                v-model="financiador.valAfiliado"
                color="primary"
                label="Valida afiliado"
              >
              </v-switch>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-n4" v-if="financiador.usaGecros">
              <v-switch
                v-model="financiador.valPrestador"
                color="primary"
                label="Valida prestador"
              >
              </v-switch>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-n4" v-if="financiador.usaGecros">
              <v-switch
                v-model="financiador.valCobertura"
                color="primary"
                label="Valida cobertura"
              >
              </v-switch>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-n4">
              <v-switch
                v-model="financiador.valDroga"
                @update:model-value="
                  financiador.valPot = financiador.valDroga
                    ? financiador.valPot
                    : false
                "
                color="primary"
                label="Valida dispensa droga"
              >
              </v-switch>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-n4">
              <v-switch
                v-model="financiador.valPot"
                :disabled="!financiador.valDroga"
                color="primary"
                label="Valida dispensa potencia"
              >
              </v-switch>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-n4" v-if="financiador.usaGecros">
              <v-switch
                v-model="financiador.autorizarDispensar"
                color="primary"
                label="Dispensar en la autorización de medicamentos"
              >
              </v-switch>
            </v-col>
            <v-col
              :cols="isMobile ? 12 : 8"
              class="py-0 mt-n3"
              v-if="financiador.usaGecros && financiador.autorizarDispensar"
            >
              <v-text-field
                label="URL Gecros WS"
                variant="outlined"
                density="compact"
                v-model="financiador.urlAutorizacionGecrosWs"
                :rules="
                  financiador.autorizarDispensar
                    ? rules.required.concat(
                        [
                          rules.maxLength(
                            financiador.urlAutorizacionGecrosWs,
                            200
                          ),
                        ],
                        rules.validUrl
                      )
                    : []
                "
              ></v-text-field>
            </v-col>
            <v-col :cols="isMobile ? 12 : 4" class="py-0 mt-n4">
              <v-switch
                v-model="financiador.informaMedSugeridos"
                color="primary"
                label="Informar medicamentos sugeridos"
              >
              </v-switch>
            </v-col>
          </v-row>
          <v-card-actions class="py-0 pr-0">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="closeModal(false)" variant="text">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              type="submit"
              :disabled="!isFormValid || lockButton"
              :loading="isLoading"
              variant="flat"
              >Confirmar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import rules from "@/utils/helpers/rules";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EditFinanciadores",
  props: {
    financiadorItem: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      financiador: {
        id: null,
        name: "",
        code: "",
        url: "",
        valDroga: false,
        valPot: false,
        valCantFechaVenc: null,
        valUniFechaVenc: null,
        valDiasEmisionFutura: 0,
        valPrestador: false,
        valAfiliado: false,
        usaAlfaBetaPropio: false,
        valCobertura: false,
        perReverDispensa: false,
        hsRevertirDispensa: null,
        informaMedSugeridos: false,
        autorizarDispensar: false,
        urlAutorizacionGecrosWs: null,
        usaGecros: true,
      },
      unidadFechaVencList: [
        {
          id: 2,
          value: "D",
          desc: "Días",
        },
        {
          id: 1,
          value: "M",
          desc: "Meses",
        },
      ],
      rules: rules,
      isFormValid: false,
      formTitle: "",
      isLoading: false,
      lockButton: false,
    };
  },
  created() {
    if (this.financiadorItem != null) {
      this.setFinanciador();
      this.formTitle = "Editar financiador";
    } else {
      this.formTitle = "Nuevo financiador";
    }
  },
  computed: {
    ...mapGetters({
      isMobile: "menu/isMobile",
    }),
  },
  methods: {
    ...mapActions({
      postFinanciador: "financiador/postFinanciador",
      setAlert: "user/setAlert",
    }),
    setFinanciador() {
      this.financiador.id = this.financiadorItem.financiadorId;
      this.financiador.name = this.financiadorItem.financiadorNom;
      this.financiador.code = this.financiadorItem.financiadorCodigo;
      this.financiador.url = this.financiadorItem.financiadorUrl;
      this.financiador.valDroga =
        this.financiadorItem.financiadorValidaDroga ?? false;
      this.financiador.valPot =
        this.financiadorItem.financiadorValidaPotencia ?? false;
      this.financiador.valUniFechaVenc =
        this.financiadorItem.financiadorValidaUnidadFechaVencimiento === ""
          ? null
          : this.financiadorItem.financiadorValidaUnidadFechaVencimiento;
      this.financiador.valCantFechaVenc =
        this.financiadorItem.financiadorValidaCantidadFechaVencimiento;
      this.financiador.valDiasEmisionFutura =
        this.financiadorItem.financiadorValidaDiasEmisionFutura == null
          ? 0
          : this.financiadorItem.financiadorValidaDiasEmisionFutura;
      this.financiador.valPrestador =
        this.financiadorItem.financiadorValidaPrestador ?? false;
      this.financiador.valAfiliado =
        this.financiadorItem.financiadorValidaAfiliado ?? false;
      this.financiador.usaAlfaBetaPropio =
        this.financiadorItem.financiadorUsaAlfaBetaPropio ?? false;
      this.financiador.valCobertura =
        this.financiadorItem.financiadorValidaCobertura ?? false;
      this.financiador.perReverDispensa =
        this.financiadorItem.financiadorPermiteRevertirDispensa ?? false;
      this.financiador.hsRevertirDispensa =
        this.financiadorItem.financiadorCantHsRevertirDispensa;
      this.financiador.informaMedSugeridos =
        this.financiadorItem.financiadorInformaMedSugeridos;
      this.financiador.autorizarDispensar =
        this.financiadorItem.financiadorAutorizarDispensar;
      this.financiador.urlAutorizacionGecrosWs =
        this.financiadorItem.financiadorUrlAutorizacionGecrosWs;
      this.financiador.usaGecros =
        this.financiadorItem.financiadorUsaGecros ?? true;
    },
    async save() {
      this.lockButton = true;
      this.isLoading = true;
      const data = {
        FinanciadorId: this.financiador.id,
        FinanciadorNom: this.financiador.name,
        FinanciadorCodigo: this.financiador.code,
        FinanciadorUrl: this.financiador.url,
        financiadorValidaPotencia: this.financiador.valPot,
        FinanciadorValidaDroga: this.financiador.valDroga,
        FinanciadorValidaUnidadFechaVencimiento:
          this.financiador.valUniFechaVenc,
        FinanciadorValidaCantidadFechaVencimiento:
          this.financiador.valCantFechaVenc,
        FinanciadorValidaDiasEmisionFutura:
          this.financiador.valDiasEmisionFutura,
        FinanciadorValidaPrestador: this.financiador.valPrestador,
        FinanciadorValidaAfiliado: this.financiador.valAfiliado,
        FinanciadorUsaAlfaBetaPropio: this.financiador.usaAlfaBetaPropio,
        FinanciadorValidaCobertura: this.financiador.valCobertura,
        FinanciadorPermiteRevertirDispensa: this.financiador.perReverDispensa,
        FinanciadorCantHsRevertirDispensa: this.financiador.hsRevertirDispensa,
        FinanciadorInformaMedSugeridos: this.financiador.informaMedSugeridos,
        FinanciadorAutorizarDispensar: this.financiador.autorizarDispensar,
        FinanciadorUrlAutorizacionGecrosWs: this.financiador.autorizarDispensar
          ? this.financiador.urlAutorizacionGecrosWs
          : null,
        FinanciadorUsaGecros: this.financiador.usaGecros,
      };
      try {
        const response = await this.postFinanciador(data);
        if (response.status === 200) {
          this.setAlert({ type: "success", message: "Guardado con éxito" });
          this.closeModal(true);
        }
      } catch (error) {
        console.error("Error al guardar cambios financiador", error);
      } finally {
        this.isLoading = false;
        this.lockButton = false;
      }
    },
    closeModal(reload) {
      this.$emit("closeAndReload", reload);
    },
  },
};
</script>

<style scoped>
.actions {
  justify-content: end;
  padding: 0px 10px 10px;
  margin-right: 5px;
}
.text {
  padding: 0px 24px;
}
.text-button {
  font-size: 18px !important;
}
</style>
